var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 6.50293,
    width: 15,
    height: 11,
    rx: 0.4,
    stroke: "#666666"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2.40137,
    width: 18,
    height: 4,
    rx: 0.2,
    stroke: "#666666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67403 7.38059C6.54436 7.06753 6.45979 6.73836 6.42229 6.40293L13.5777 6.40293C13.5402 6.73837 13.4556 7.06753 13.326 7.38059C13.145 7.81736 12.8799 8.21422 12.5456 8.54851C12.2113 8.8828 11.8144 9.14798 11.3777 9.3289C10.9409 9.50981 10.4728 9.60293 10 9.60293C9.52724 9.60293 9.05911 9.50981 8.62234 9.3289C8.18557 9.14798 7.78871 8.8828 7.45442 8.54851C7.12012 8.21422 6.85495 7.81736 6.67403 7.38059Z",
    stroke: "#666666",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.6d620c60f0795d3091caeb69fca7c1de.svg";
export { ForwardRef as ReactComponent };